// extracted by mini-css-extract-plugin
export default {"orderHeading":"Orders_orderHeading__4qfUs","orderCard":"Orders_orderCard__KgVfe","title":"Orders_title__5jkkW"};